@let currentDraft = draft();
@let currentErrors = errors();

<section
  class="wishlist-create-visibility-selector"
  aria-label="Widoczność wishlisty"
>
  <div class="wishlist-create-visibility-selector__options">
    <ui-choice-group
      ariaLabel="Widoczność wishlisty"
      [options]="options()"
      [selectedOptionId]="currentDraft.visibility"
      layout="stack"
      [required]="true"
      [invalid]="currentErrors.visibility !== null"
      [describedBy]="
        currentErrors.visibility ? 'wishlist-create-visibility-error' : null
      "
      (selectedOptionIdChange)="handleVisibilityOptionSelected($event)"
    />
  </div>

  @if (currentErrors.visibility) {
    <p
      id="wishlist-create-visibility-error"
      class="wishlist-create-visibility-selector__error"
      role="alert"
    >
      {{ currentErrors.visibility }}
    </p>
  }

  @if (currentDraft.visibility === 'invited_only') {
    <div class="wishlist-create-visibility-selector__panel">
      <ui-input
        label="Email zaproszonej osoby"
        name="invitedEmail"
        type="email"
        placeholder="np. babcia@example.com"
        [value]="invitedEmailDraft()"
        [errorText]="invitedEmailError() ?? currentErrors.invitedEmail"
        (valueChange)="handleInvitedEmailDraftChange($event)"
      />

      <ui-button
        size="sm"
        variant="secondary"
        (pressed)="handleInvitedEmailAddSelected()"
      >
        Dodaj email
      </ui-button>

      @if (currentDraft.invitedEmails.length > 0) {
        <ul
          class="wishlist-create-visibility-selector__email-list"
          aria-label="Zaproszone osoby"
        >
          @for (email of currentDraft.invitedEmails; track email) {
            <li>
              <span>{{ email }}</span>
              <ui-icon-button
                variant="soft"
                [ariaLabel]="'Usuń ' + email"
                (pressed)="handleInvitedEmailRemoveSelected(email)"
              >
                x
              </ui-icon-button>
            </li>
          }
        </ul>
      }
    </div>
  }

  @if (currentDraft.visibility === 'anyone_with_link') {
    <div class="wishlist-create-visibility-selector__panel">
      Link będzie dostępny po utworzeniu wishlisty w szczegółach listy.
    </div>
  }

  <div class="wishlist-create-visibility-selector__hint">
    Lista domyślnie jest prywatna. Udostępnianie skonfigurujesz w szczegółach
    wishlisty.
  </div>
</section>
